/**
 * The article page's own ground.
 *
 * Named once because six things paint it: the shell wrapper behind the page,
 * the nav's own band, and the four blocks that have to be opaque so they hide
 * the pinned nav as they travel over it — the banner wrapper, the module list,
 * the closing block and the reading rails. Change it here and every one of
 * them follows.
 */
export const ARTICLE_GROUND = 'bg-ground max-md:ground-grey';
